type WebTabIconProps = {
  size?: number;
  color?: string;
  active?: boolean;
  fgColor?: string;
  framed?: boolean;
  className?: string;
};

const HOME_PATH =
  "M4.6 13.15C4.6 12.65 4.83 12.19 5.22 11.87L12.3 5.95C12.71 5.61 13.29 5.61 13.7 5.95L20.78 11.87C21.17 12.19 21.4 12.65 21.4 13.15v7.05a1.8 1.8 0 0 1-1.8 1.8h-4.3v-6.5h-4.6V22H6.4a1.8 1.8 0 0 1-1.8-1.8v-7.05z";

export function TabFeedIcon({ size = 26, color = "currentColor", active, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
        <path d={HOME_PATH} fill={color} stroke={color} strokeWidth={1} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
      <path d={HOME_PATH} stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export function TabSearchIcon({ size = 26, color = "currentColor", active, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
        <circle cx={11.3} cy={11.3} r={6.2} fill={color} />
        <line x1={16} y1={16} x2={21} y2={21} stroke={color} strokeWidth={3} strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
      <circle cx={11.3} cy={11.3} r={6.2} stroke={color} strokeWidth={1.8} />
      <line x1={16} y1={16} x2={21} y2={21} stroke={color} strokeWidth={1.8} strokeLinecap="round" />
    </svg>
  );
}

export function TabCreateIcon({ size = 26, color = "currentColor", active, fgColor = "var(--scroll-bg)", framed = true, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
        {framed && <rect x={2} y={2} width={22} height={22} rx={7} fill={color} />}
        <line x1={13} y1={7.5} x2={13} y2={18.5} stroke={framed ? fgColor : color} strokeWidth={2.5} strokeLinecap="round" />
        <line x1={7.5} y1={13} x2={18.5} y2={13} stroke={framed ? fgColor : color} strokeWidth={2.5} strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
      {framed && <rect x={2} y={2} width={22} height={22} rx={7} stroke={color} strokeWidth={2} />}
      <line x1={13} y1={7.5} x2={13} y2={18.5} stroke={color} strokeWidth={2.2} strokeLinecap="round" />
      <line x1={7.5} y1={13} x2={18.5} y2={13} stroke={color} strokeWidth={2.2} strokeLinecap="round" />
    </svg>
  );
}

export function TabPodcastsIcon({ size = 26, color = "currentColor", active, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
        <rect x={10} y={4} width={6} height={10} rx={3} fill={color} />
        <path d="M7 12a6 6 0 0 0 12 0" stroke={color} strokeWidth={2} strokeLinecap="round" />
        <line x1={13} y1={18} x2={13} y2={22} stroke={color} strokeWidth={2} strokeLinecap="round" />
        <line x1={10} y1={22} x2={16} y2={22} stroke={color} strokeWidth={2} strokeLinecap="round" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
      <rect x={10} y={4} width={6} height={10} rx={3} stroke={color} strokeWidth={1.8} fill="none" />
      <path d="M7 12a6 6 0 0 0 12 0" stroke={color} strokeWidth={1.8} strokeLinecap="round" />
      <line x1={13} y1={18} x2={13} y2={22} stroke={color} strokeWidth={1.8} strokeLinecap="round" />
      <line x1={10} y1={22} x2={16} y2={22} stroke={color} strokeWidth={1.8} strokeLinecap="round" />
    </svg>
  );
}

export function TabWatchIcon({ size = 26, color = "currentColor", active, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
        <path
          d="M7 5h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4zM11 9.5v7l6-3.5-6-3.5z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
      <rect x={3} y={5} width={20} height={16} rx={4} stroke={color} strokeWidth={1.8} fill="none" />
      <path d="M11 9.5l6 3.5-6 3.5V9.5z" stroke={color} strokeWidth={1.8} strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export function HeaderActivityIcon({ size = 26, color = "currentColor", active, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
        <path
          d="M19.5 12.6 12 20l-7.5-7.4A5 5 0 0 1 12 6a5 5 0 0 1 7.5 6.6z"
          fill={color}
          stroke={color}
          strokeWidth={1.25}
          strokeLinejoin="round"
          strokeLinecap="round"
        />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M19.5 12.6 12 20l-7.5-7.4A5 5 0 0 1 12 6a5 5 0 0 1 7.5 6.6z"
        stroke={color}
        strokeWidth={1.75}
        strokeLinejoin="round"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}

export function TabProfileIcon({ size = 26, color = "currentColor", active, className }: WebTabIconProps) {
  if (active) {
    return (
      <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
        <path
          d="M13 13.6a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6zM4.7 22c.72-4.3 3.7-6.7 8.3-6.7s7.58 2.4 8.3 6.7H4.7z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 26 26" fill="none" className={className} aria-hidden>
      <circle cx={13} cy={8.8} r={4.6} stroke={color} strokeWidth={1.8} />
      <path
        d="M4.7 22c.72-4.3 3.7-6.7 8.3-6.7s7.58 2.4 8.3 6.7"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
